import { Dialog, DialogContent, DialogActions, DialogTitle, Button, Grid2, Box } from '@mui/material'
import { Form, Formik } from 'formik';
import * as Yup from 'yup';
import MyNumberInput from '../../../components/inputs/MyNumberInput';
import MyAutoComplete from '../../../components/inputs/MyAutoComplete';
import MyDateTimePicker from '../../../components/inputs/MyDateTimePicker';
import { myApi } from '../../../config/axiosConfig';
import Swal from 'sweetalert2';
import Cookies from 'js-cookie';

function CrearEditarPrecio({ open, onClose, refresh, precio, isEditing }) {

    const validationSchema = Yup.object({
        fecha: Yup.string().required('La fecha es obligatoria'),
        precio: Yup.number()
        .transform((value, originalValue) => {
        // Limpia el símbolo de $ y otros caracteres no numéricos
        if (typeof originalValue === 'string') {
            const cleaned = originalValue.replace(/[^0-9.,-]/g, '').replace(',', '.');
            return parseFloat(cleaned);
        }
        return value;
        })
        .typeError('Debe ser un número válido')
        .required('El precio es obligatorio')
        .min(0, 'El precio no puede ser negativo')
        .moreThan(0, 'El precio debe ser mayor que 0'),
        fuente: Yup.string().required('El establecimiento es obligatorio'),
        moneda: Yup.string().required('La moneda es obligatoria'),
        tipo: Yup.string().required('El producto es obligatorio'),
    });

    const initialValues = {
        fecha: precio?.fecha || '',
        precio: precio?.precio || '',
        moneda: precio?.moneda || '',
        fuente:
            precio?.fuente === "DEF_COLOMBIA"
                ? "COLOMBIA"
                : precio?.fuente === "DEF_ARGUINDEGUI"
                    ? "ARGUINDEGUI"
                    : precio?.fuente || "",
        tipo:
            precio?.tipo !== null &&
            precio?.tipo !== undefined
                ? String(precio.tipo)
                : "",
        usuario: Cookies.get('ebt_nombre')
    };

    const handleSubmit = async (values) => {

        const isDef =
            String(values.tipo) === "3";

        const payload = {
            fecha: values.fecha,
            precio: values.precio,
            moneda: values.moneda,
            fuente: isDef
                ? `DEF_${values.fuente}`
                : values.fuente,
            tipo: values.tipo,
            usuario: values.usuario
        };

        try 
        {
            if (isEditing) 
            {
                let responseEditar = await myApi.put(`/cargasFuel/editarPrecio/${precio.id}`, payload);

                if(responseEditar.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Precio editado',
                    });
                    refresh();
                    onClose();
                }
                else
                {
                    if (responseEditar.data.errorCode === 'DUPLICATE_ENTRY') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error de duplicidad',
                            text: responseEditar.data.data || 'Ya existe un precio con esa fecha y establecimiento'
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al editar precio',
                            text: responseEditar.data.data || 'Ocurrió un error desconocido',
                        });
                    }

                    console.error('Error de API:', responseEditar.data);
                }
            } 
            else 
            {
                let responseCrear = await myApi.post('/cargasFuel/crearPrecio', payload);

                if(responseCrear.data.success)
                {
                    Swal.fire({
                        icon: 'success',
                        title: 'Precio creado',
                    });
                    refresh();
                    onClose();
                }
                else
                {
                    if (responseCrear.data.errorCode === 'DUPLICATE_ENTRY') {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error de duplicidad',
                            text: responseCrear.data.data || 'Ya existe un precio con esa fecha y establecimiento'
                        });
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error al crear precio',
                            text: responseCrear.data.data || 'Ocurrió un error desconocido',
                        });
                    }

                    console.error('Error de API:', responseCrear.data);
                }
            }
            refresh();
            onClose();
        } 
        catch (error) 
        {
            console.error('Error saving price:', error);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle>{isEditing ? 'Editar Precio' : 'Crear Precio'}</DialogTitle>
            <DialogContent>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({ handleSubmit, errors, touched, values, setFieldValue }) => {
                    
                    if ( values.fuente === "COLOMBIA" && !["1", "3"].includes(String(values.tipo))) 
                    {
                        setFieldValue("tipo", "1");
                    }
                    if (values.fuente === 'LAREDO' && values.tipo !== '1') 
                    {
                        setFieldValue('tipo', '1');
                    }
                    if (values.fuente === 'MONTERREY' && values.tipo !== '1') 
                    {
                        setFieldValue('tipo', '1');
                    }

                    const isLaredo = values.fuente === 'LAREDO';
                    const isMty = values.fuente === 'MONTERREY';

                    const productOptions =
                        values.fuente === "COLOMBIA"
                            ? [
                                {
                                    value: "1",
                                    label: "CLEAR DIESEL"
                                },
                                {
                                    value: "3",
                                    label: "DEF"
                                }
                            ]
                            : [
                                {
                                    value: "1",
                                    label: "CLEAR DIESEL"
                                },
                                {
                                    value: "2",
                                    label: "RED DIESEL"
                                },
                                {
                                    value: "3",
                                    label: "DEF"
                                }
                            ];

                    return (
                        <Form onSubmit={handleSubmit} style={{ width: '100%' }}>
                            <Grid2 container spacing={2}>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyDateTimePicker
                                        name="fecha"
                                        label="FECHA"
                                        views={['year', 'month', 'day']}
                                        error={touched.fecha && Boolean(errors.fecha)}
                                        helperText={touched.fecha && errors.fecha}
                                    />
                                    {errors.fecha && touched.fecha ? (
                                        <div style={{ color: '#D3302F', fontSize: '12px' }}>{errors.fecha}</div>
                                    ) : null}
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyNumberInput
                                        name="precio"
                                        label="PRECIO"
                                    />
                                </Grid2>
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoComplete
                                        name="moneda"
                                        label="MONEDA"
                                        options={[{ value: 'MXN', label: 'MXN' }, { value: 'USD', label: 'USD' }]}
                                    />
                                </Grid2> 
                                <Grid2 size={{ xs: 12, sm: 4 }}>
                                    <MyAutoComplete
                                        name="fuente"
                                        label="ESTABLECIMIENTO"
                                        options={[
                                            {
                                                value: "ARGUINDEGUI",
                                                label: "ARGUINDEGUI"
                                            },
                                            {
                                                value: "COLOMBIA",
                                                label: "COLOMBIA"
                                            },
                                            {
                                                value: "LAREDO",
                                                label: "LAREDO"
                                            },
                                            {
                                                value: "MONTERREY",
                                                label: "MONTERREY"
                                            }
                                        ]}
                                    />
                                </Grid2>
                                {/* Mostrar producto en Colombia y Arguindegui */}
                                {!isLaredo &&
                                !isMty && (
                                    <Grid2 size={{ xs: 12, sm: 4 }}>
                                        <MyAutoComplete
                                            name="tipo"
                                            label="PRODUCTO"
                                            options={productOptions}
                                        />
                                    </Grid2>
                                )}
                                <DialogActions style={{ justifyContent: 'flex-end' }}>
                                    <Button type="submit" variant="contained" color="primary">
                                        Guardar
                                    </Button>
                                    <Button onClick={onClose}>Cancelar</Button>
                                </DialogActions>
                            </Grid2>
                        </Form>
                    )}}
                </Formik>
            </DialogContent>
        </Dialog>
    )
}

export default CrearEditarPrecio